import type { DocumentNode } from '@apollo/client';
import type { DefinitionNode, ExecutableDefinitionNode } from 'graphql/language/ast';

const isOperationDefinition = (definition: DefinitionNode | undefined): definition is ExecutableDefinitionNode =>
  definition?.kind === 'OperationDefinition';

export const extractOperationName = (document: DocumentNode): string => {
  const definition = document.definitions.find(({ kind }) => kind === 'OperationDefinition');

  if (isOperationDefinition(definition)) {
    const operationName = definition.name?.value;

    if (operationName) {
      return operationName;
    }

    throw new Error('Could not find operation name from query document');
  }

  throw new Error('Could not extract ExecutableDefinitionNode from document');
};
